let ctx = null;
let master = null;
const VKEY = "lg_volume";

export const getVolume = () => {
  const v = parseFloat(localStorage.getItem(VKEY));
  return Number.isFinite(v) ? v : 0.9;
};

export function setVolume(v) {
  localStorage.setItem(VKEY, String(v));
  if (master) master.gain.value = v;
}

export function unlockAudio() {
  const AC = window.AudioContext || window.webkitAudioContext;
  if (!AC) return false;
  if (!ctx) {
    ctx = new AC();
    master = ctx.createGain();
    master.gain.value = getVolume();
    master.connect(ctx.destination);
  }
  if (ctx.state !== "running") ctx.resume().catch(() => {});
  return true;
}

export const soundReady = () => !!ctx && ctx.state === "running";

function tone(freq, start, dur, gain = 0.25, type = "sine") {
  const o = ctx.createOscillator();
  const g = ctx.createGain();
  const t = ctx.currentTime + start;
  o.type = type;
  o.frequency.value = freq;
  g.gain.setValueAtTime(0.0001, t);
  g.gain.exponentialRampToValueAtTime(gain, t + 0.02);
  g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
  o.connect(g).connect(master);
  o.start(t);
  o.stop(t + dur + 0.05);
}

const seq = (notes, step, dur, gain, type, offset = 0) => notes.forEach((f, i) => tone(f, offset + i * step, dur, gain, type));

const SOUNDS = {
  // staff: order paid / placed — urgent ding-dong, twice
  new_order: () => { [0, 0.7].forEach((o) => { tone(880, o, 0.2, 0.35, "triangle"); tone(1174.7, o + 0.22, 0.35, 0.35, "triangle"); }); },
  // customer: payment confirmed / order placed — soft rising two notes
  payment_confirmed: () => { tone(1046.5, 0, 0.25, 0.25); tone(1568, 0.18, 0.45, 0.25); },
  // both: manual order approved — bright three-note rise
  approved: () => seq([523.25, 659.25, 783.99], 0.12, 0.3, 0.3, "square"),
  // both: preparing — low double knock
  preparing: () => { tone(330, 0, 0.18, 0.4); tone(220, 0, 0.18, 0.25, "triangle"); tone(330, 0.25, 0.18, 0.4); tone(220, 0.25, 0.18, 0.25, "triangle"); },
  // both: ready — loudest, long fanfare, three times
  ready: () => { [0, 1.0, 2.0].forEach((o) => { seq([659.25, 830.61, 987.77, 1318.5], 0.12, 0.5, 0.55, "sawtooth", o); seq([659.25, 830.61, 987.77, 1318.5], 0.12, 0.5, 0.4, "square", o); }); },
  // both: picked up — short closing descend
  picked_up: () => { tone(783.99, 0, 0.15, 0.22); tone(523.25, 0.14, 0.3, 0.22); },
  // both: cancelled / rejected / refunded / expired / no-show — descending buzz
  alert: () => seq([392, 311.13, 246.94], 0.22, 0.25, 0.35, "sawtooth"),
};

export const SOUND_LABELS = [
  ["new_order", "New order (staff)"], ["payment_confirmed", "Payment confirmed (customer)"], ["approved", "Approved"],
  ["preparing", "Preparing"], ["ready", "Ready — loudest"], ["picked_up", "Picked up"], ["alert", "Cancelled / rejected / refunded"],
];

export function play(name) {
  if (!unlockAudio() || !SOUNDS[name]) return;
  SOUNDS[name]();
}

export const PRIORITY = ["alert", "ready", "new_order", "payment_confirmed", "approved", "preparing", "picked_up"];
const ENDED = ["cancelled", "rejected", "refunded", "expired", "no_show"];

export function soundForTransition(prev, next, side) {
  if (ENDED.includes(next)) return "alert";
  if (next === "ready") return "ready";
  if (next === "picked_up") return "picked_up";
  if (next === "preparing") return prev === "awaiting_approval" ? "approved" : "preparing";
  if (next === "paid" || next === "awaiting_approval") return side === "staff" ? "new_order" : "payment_confirmed";
  return null;
}

export const playNewOrder = () => play("new_order");
